import { useTranslation } from "react-i18next";
import { Section, SectionBody, SectionTitle, SectionContent } from "./styles";
import { useAddOnsStrings } from "screens/offer-bc/utils";
import { AddOnItems } from "./add-on-items";

export interface AddOnsProps {
  coloredSection?: boolean;
}

export function AddOns({ coloredSection }: AddOnsProps) {
  const { t } = useTranslation("screens", { keyPrefix: "offer.addOns" });
  const addOnsStrings = useAddOnsStrings();

  return (
    <Section className={coloredSection ? "colored" : ""}>
      <SectionBody>
        <SectionTitle>{t("title")}</SectionTitle>
        <SectionContent>
          <AddOnItems addOns={addOnsStrings.addOns} />
        </SectionContent>
      </SectionBody>
      {!!addOnsStrings.extraAddOns.length && (
        <SectionBody>
          <SectionTitle>{t("extrasTitle")}</SectionTitle>
          <SectionContent>
            <AddOnItems addOns={addOnsStrings.extraAddOns} />
          </SectionContent>
        </SectionBody>
      )}
    </Section>
  );
}
